import axios from "axios";
import { logOut } from "../../../../components/Logout";
import { handleGetLocal } from "../../../../services/auth-service";
import {
  setGoToobligationIsChange,
} from "../../../../reducer/ParticipateReducer";
import { setgotooblogationValue } from "../../../../reducer/participantNoteReducer";
import {
  setEmEquipmentLogObligationTableData,
  setEmPeriodObligationTableData,
  setObligationOverviewTableData,
  setTableDisbursementTableData,
  setTableGeneratePaymentPlanTableData,
  setTableRecipientsTableData,
} from "./GoTOObligationSubTabs/Data";
import { removeDynamicTab, setDynamicTab } from "../../../../reducer/HomePageReducer";
import moment from "moment/moment";


export class GoTOObligationFunction {
  constructor() {
    this.pathname = handleGetLocal("pathURL");

  }

  getattachmentTableData = async (
    setattachmentTabledata,
    setLoading,
    navigate,
    gotooblogationValue,
    setattachmentCount
  ) => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/attachments/get-attachments?recordId=${gotooblogationValue?.gObligationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        setattachmentCount(val?.data?.data?.length);
        setattachmentTabledata(this.setTableData(val?.data?.data));
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  getObligation = async (
    navigate,
    gotooblogationValue
  ) => {
    if (gotooblogationValue?.gObligationId) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/obligations/getObligation?obligationId=${gotooblogationValue?.gObligationId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              Domain: `${this.pathname}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        if (!error?.response) {
          navigate(`/error/500`);
        } else if (error?.response?.status === 401) {
          logOut();
        } else {
          throw new Error("Something went wrong!");
        }
      }
    }
    return null;  // Return null if no obligation ID is provided
  };

  getDRopDown = async (
    navigate,
    setRecipientCategorye,
    setOffense,
    setFinancialStatus,
    setdropdowndata,
    setField2
  ) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/docket-dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setdropdowndata(val?.data?.data);
        val?.data?.data?.recipientCategory?.length &&
          setRecipientCategorye(
            val?.data?.data?.recipientCategory.map((val) => {
              return {
                name: val?.value,
                id: val?.key,
              };
            })
          );

        val?.data?.data?.offenses?.length &&
          setOffense(
            val?.data?.data?.offenses.map((val) => {
              return {
                name: val?.value,
                id: val?.key,
              };
            })
          );

        val?.data?.data?.financialStatuses?.length &&
          setFinancialStatus(
            val?.data?.data?.financialStatuses.map((val) => {
              return {
                name: val?.value,
                id: val?.key,
              };
            })
          );

        val?.data?.data?.defaultFinancialStatus &&
          setField2((prev) => {
            return {
              ...prev,
              "Financial Status": {
                name: val?.data?.data?.defaultFinancialStatus?.value,
                id: val?.data?.data?.defaultFinancialStatus?.key,
              },
            };
          });
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  getFinancialStatusDropdown = async (
    navigate,
    setFinancialStatus,
    setdropdowndata,
  ) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/docket-dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setdropdowndata(val?.data?.data);
        val?.data?.data?.financialStatuses?.length &&
          setFinancialStatus(
            val?.data?.data?.financialStatuses?.map((val) => {
              return {
                name: val?.value,
                id: val?.key,
              };
            })
          );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  setTableData = (dataa) => {
    const arr = [];
    dataa.map((val) => {
      arr.push({
        Filename: val?.filename,
        Category: val?.attachmentCateogoryName,
        Description: val?.description,
        ID: val?.recordId,
        "Entered By": val?.enteredByUserName,
        DOE: val?.doe,
        attachment: val?.attachment,
        attachmentCategoryId: val?.attachmentCategoryId,
        binaryDataId: val?.binaryDataId,
        image: val?.image,
      });
    });

    return arr;
  };

  Save = async (body,
    navigate
  ) => {
    const response = await axios
      .post(`${process.env.REACT_APP_API_URL}/api/obligations/addEditObligation`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      return response;
  };

  Cloneobligation = async (
    setLoading,
    toastConfig,
    setToastConfig,
    navigate,
    gotooblogationValue,
    body,
    setcloneObligation,
    dispatch
  ) => {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/obligations/clone-obligation`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.isSuccess) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Successfully Updated!",
              type: "success",
            });
          }, 1400);

          dispatch(
            setDynamicTab({
              Offender: `/obligation/${val?.data?.data?.gObligationId}/${val?.data?.data?.sReference
                }`,
              link: `/obligation/${val?.data?.data?.gObligationId}/${val?.data?.data?.sReference
                }`,
              title: `Obligation : ${val?.data?.data?.sDocketNumberCourtCounts} / ${val?.data?.data?.sReference}`,
              sDocketNumberCourtCounts: val?.data?.data?.sDocketNumberCourtCounts,
              ObligationRef: val?.data?.data?.sReference,
              gObligationId: val?.data?.data?.gObligationId,
              userinfo: val?.data?.data?.userinfo,
            })
          );
          dispatch(
            setgotooblogationValue({
              gObligationId: val?.data?.data?.gObligationId,
              userinfo: val?.data?.data?.userinfo,
            })
          );
          navigate(
            `/obligation/${val?.data?.data?.gObligationId}/${val?.data?.data?.sReference
            }`
          );

          setcloneObligation(false);
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Obligation already exists!",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Obligation already exists!",
              type: "error",
            });
          }, 1400);
        }
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Obligation already exists!",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Obligation already exists!",
              type: "error",
            });
          }, 1400);
        }
      });
  };

  async getFIndTable(setLoading, search, setdata, navigate) {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/find-obligation?search=${search ? search : null}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.isSuccess) {
          setdata(this.setobligationFindTable(val?.data?.data));
        }
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  }

  setobligationFindTable = (data) => {
    const arr = [];
    data.map((val, i) => {
      arr.push({
        "Obligation Ref #": val?.sReference,
        Offender: val?.sPersonNameLastFirst,
        "Case Folder": "",
        "Case Ref #": "",
        sDocketNumberCourtCounts: val?.sDocketNumberCourtCounts,
        ID: i,
        gObligationID: val?.gObligationID,
        userinfo: val,
      });
    });
    return arr;
  };

  async getFIndDocketTable(setLoading, search, setdata, navigate) {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/find?search=${search ? search : null}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.isSuccess) {
          setdata(this.setDocketFindTable(val?.data?.data));
        }
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  }

  setDocketFindTable = (data) => {
    const arr = [];
    data.map((val, i) => {
      arr.push({
        Reference: val?.sReferenceNumber,
        Location: val?.sGPMLocation_EntityName,
        "Docket #": val?.sDocketNumberCourtCounts,
        Offender: val?.sPersonNameLastFirst,
        "Offender #": val?.sOffenderNumber,
        SSN: val?.sSSNx4,
        "Alt ID": val?.s,
        "Court / Agency": val?.s,
        "Sent Date": val?.s,
        ID: i,
        gDocketID: val?.gDocketID,
        gPersonId: val?.gPersonID,
      });
    });
    return arr;
  };

  async changesupervisionstatus(
    setField,
    setLoading2,
    body,
    setToastConfig,
    toastConfig,
    navigate,
    setChangeFinatialSTatusPopup,
    getObligation
  ) {
    setLoading2(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/obligations/change-financial-status`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.isSuccess) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Successfully Updated!",
              type: "success",
            });
          }, 1400);
          getObligation();
          setChangeFinatialSTatusPopup(false);
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "error!",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "error!",
              type: "error",
            });
          }, 1400);
        }
        setLoading2(false);
      })
      .catch((val) => {
        setLoading2(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Network Error!",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Network Error!",
              type: "error",
            });
          }, 1400);
        }
      });
  }

  

  getRecipientsTableData = async (
    setLoading,
    navigate,
    gotooblogationValue,
    setRecipientsTableData,
    setRecipientsCount
  ) => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/Obligations/get-recipient-pannel?gObligationId=${gotooblogationValue?.gObligationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        setRecipientsCount(val?.data?.data?.length);
        setRecipientsTableData(setTableRecipientsTableData(val?.data?.data));
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  

  getDisbursementTableData = async (
    setLoading,
    navigate,
    gotooblogationValue,
    setDisbursementsTableData,
    setDisbursementsCount
  ) => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/Obligations/get-disbursement-pannel?gObligationId=${gotooblogationValue?.gObligationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        setDisbursementsCount(val?.data?.data?.length);
        setDisbursementsTableData(setTableDisbursementTableData(val?.data?.data));
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getPaymentCreditsTableData = async (
    setLoading,
    navigate,
    gotooblogationValue,
    setPaymentCreditsTableData,
    setPaymentCreditsCount
  ) => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/obligations/obligation-payments-credits?gObligationID=${gotooblogationValue?.gObligationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        setPaymentCreditsCount(val?.data.data?.length);
        setPaymentCreditsTableData(setObligationOverviewTableData(val?.data?.data));
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getRecipientsDropdownData = async (
    setLoading,
    navigate,
    setRecipientsDropdownData,
    setRecipientsPaymentDropdownData,
    setRecipientsEntityDropdownData
  ) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        setRecipientsDropdownData(val?.data?.data);
        setRecipientsPaymentDropdownData(
          val?.data?.data?.bakAccount?.map((item) => {
            return {
              "Account Name": item?.sName,
              "Account Number": item?.sAccountNumber,
              gBankAccountId: item?.gBankAccountId,
              gBankId: item?.gBankId,
              gEntryUserId: item?.gEntryUserId,
            };
          })
        );
        setRecipientsEntityDropdownData(
          val?.data?.data?.entity?.map((item) => {
            return {
              Entity: item?.sName,
              Type: item?.sEntityTypeName,
              "Address?": item?.bIsBilling,
              gEntityId: item?.gEntityId,
              gReportingEntityId: item?.gReportingEntityId,
            };
          })
        );
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getpaymentCreditsDropdownData = async (setLoading, navigate, setPaymentCreditsDropdownData) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/Payment/masterDropDownValuesGet`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setPaymentCreditsDropdownData(val?.data?.data);
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getRecipientsInputsAddressData = async (setLoading, navigate, gRestitutionRecipientId, setFields) => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/obligations/get-recipient?gRestitutionRecipientId=${gRestitutionRecipientId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setFields((prev) => ({
          ...prev,
          firstName: val?.data?.data?.sFirstName,
          lastCompany: val?.data?.data?.sLastName,
          addressLine1: val?.data?.data?.sAddress1,
          addressLine2: val?.data?.data?.sAddress2,
          city: val?.data?.data?.sCityName,
          state: val?.data?.data?.sState,
          zip: val?.data?.data?.sZip,
          zipCode: val?.data?.data?.sZip4,
          country: val?.data?.data?.sCounty,
          commentsPhone: val?.data?.data?.sAddressComment,
        }));
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getFeeViolationDropdown = async (navigate, setFeeViolationDropdown) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/generic-parameter-lookup?parameter=Fee Schedule Fee`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {

        setFeeViolationDropdown(
          val?.data?.data.map((item) => {
            return {
              name: item?.value,
              id: item?.id,
            };
          })
        );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getViolationFeeFineDropdown = async (gFeeScheduleID, navigate, setPaymentAgencyEntity) => {
    if (!gFeeScheduleID) {
      return;
    }
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/get-violation-fines?feeViolationId=${gFeeScheduleID}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        let nameData = val?.data?.data.map((item) => {
          return {
            sFineAmountName: item?.sFineAmountName,
          };
        });
        setPaymentAgencyEntity(nameData[0]?.sFineAmountName);
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getGeneratePaymentPlanTableData = async (
    setLoading,
    navigate,
    gotooblogationValue,
    setGeneratePaymentPlanTableData
  ) => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/obligations/get-paymentplan?gObligationId=${gotooblogationValue?.gObligationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setGeneratePaymentPlanTableData(setTableGeneratePaymentPlanTableData(val?.data?.data));
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getFeeCodeChangeData = async (gFeeScheduleId, setLoading, navigate, setFields) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/amount-fee-schedule?gFeeScheduleFeeID=${gFeeScheduleId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setFields((prev) => ({
          ...prev,
          adjustmentAmount: val?.data?.data?.fFee,
          feeDescription: `${val?.data?.data?.sLocalViolationDescription} `,
          paymentAgencyEntity: val?.data?.data?.sFineAmountName,
        }));
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getPaymentPlanDropdownData = async (gotooblogationValue, setMonthStartDropdown, setLoading, navigate) => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/docket/get-payment-plan?obligationId=${gotooblogationValue?.gObligationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      )
      .then((val) => {
        setMonthStartDropdown(
          val?.data?.data?.monthStartOffsets.map((val) => {
            return {
              name: val?.value,
              id: val?.key,
            };
          })
        );
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  FeeCodeGEtDropDownApi = async (setfeecodedropdown, navigate) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/generic-parameter-lookup?parameter=Fee Schedule Fee`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.isSuccess) {
          setfeecodedropdown(
            val?.data?.data?.map((vall) => {
              return {
                name: vall?.value,
                id: vall?.id,
              };
            })
          );
        }
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  
  GetDefaultBilllingEntity = async (setDefaultbillingentity, navigate,gDocketID) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/get-default-billing-entity?gDocketId=${gDocketID}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.isSuccess) {
          setDefaultbillingentity(
            val?.data?.data
          );
        }
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  getPaymentAgencyDropdown = async (setPaymentAgency, navigate) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/generic-parameter-lookup?parameter=Billing Agency`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        val?.data?.data?.length &&
          setPaymentAgency(
            val?.data?.data?.map((vall) => {
              return {
                name: vall.value,
                id: vall.id ? vall.id : "00000000-0000-0000-0000-000000000000",
              };
            })
          );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getEmPeriodObligationTableData = async (setLoading, navigate, gObligationID, setEmPeriodTableData) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/getPeriodObligation?obligationId=${gObligationID}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setEmPeriodTableData(setEmPeriodObligationTableData(val?.data?.data));
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getVEmPeriodDataByDocketId(gDocketId, setLoading, setVEmPeriodData, navigate) {
  setLoading(true);
  axios
    .get(`${process.env.REACT_APP_API_URL}/api/em/get-em-child?gDocketId=${gDocketId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        Domain: `${this.pathname}`,
      },
    })
    .then((response) => {
      console.log("vemperios response",response?.data?.data)
      setLoading(false);
      setVEmPeriodData(response?.data?.data || []);
      
    })
    .catch((error) => {
      setLoading(false);
      console.error("Error fetching vEM_Period data:", error);
      if (!error?.response) {
        navigate("/error/500");
      } else if (error?.response?.status === 401) {
        logOut();
      }
    });
}


  getEmEquipmentLogObligationTableData = async (setLoading, navigate, gObligationID, setEmEquipmentLogTableData) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/getEquipmentLog?obligationId=${gObligationID}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.data) setEmEquipmentLogTableData(setEmEquipmentLogObligationTableData(val?.data?.data));
        else setEmEquipmentLogTableData([]);
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getPaymentPlanFlag = async (setLoading, navigate, setPaymentPlanFlag, setObligationRefMessage) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/playment-plan-flag`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setPaymentPlanFlag(val?.data?.data);
        setObligationRefMessage(val?.data?.responseMessage);
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getEmPeriodDropdownData = async (
    navigate,
    setFrequencyDropdownData,
    setEmTypeDropdownData,
    setPaymentTypeDropdownData,
    setEquipmentTypeDropdownData
  ) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setEmTypeDropdownData(
          val?.data?.data?.emType.map((item) => {
            return {
              name: item?.value,
              id: item?.key,
            };
          })
        );
        setFrequencyDropdownData(
          val?.data?.data?.frequency.map((item) => {
            return {
              name: item?.value,
              id: item?.key,
            };
          })
        );
        setPaymentTypeDropdownData(
          val?.data?.data?.paymentType.map((item) => {
            return {
              name: item?.value,
              id: item?.key,
            };
          })
        );
        console.log( "payment type",val?.data?.data?.paymentType)
        setEquipmentTypeDropdownData(
          val?.data?.data?.equipmentType.map((item) => {
            return {
              name: item?.value,
              id: item?.key,
            };
          })
        );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  getObligationDropdownData = async (navigate, gPersonId, setObligationDropdownData) => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/dropdown?gPersonId=${gPersonId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setObligationDropdownData(
          val?.data?.data?.obligation.map((item) => {
            return {
              name: item?.sDdsviolationDescription,
              id: item?.gObligationId,
              type: item?.sFeeScheduleType,
            };
          })
        );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  async addEditPeriodObligation(
    navigate,
    setLoading,
    setToastConfig,
    toastConfig,
    apiPayload,
    typeTab,
    setAddEditEMPeriodPopup,
    refreshApi,
    refreshObligationHeader 
  ) {
    setLoading(true);
    apiPayload.DRateEnd = apiPayload?.DRateEnd ? moment(apiPayload?.DRateEnd).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;
    apiPayload.DRateStart = apiPayload?.DRateStart ? moment(apiPayload?.DRateStart).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;
    // console.log("apipayload.gendreasonid",apiPayload.GEndReasonId)
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/obligations/addEditPeriodObligation`, apiPayload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        console.log("after saving data",val?.data)
        setLoading(false);
        if (val?.data?.isSuccess) {
          setAddEditEMPeriodPopup(false);
          refreshApi();
          if (refreshObligationHeader) {
          refreshObligationHeader();
          console.log("OB.1 header refreshed automatically");
        }
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: typeTab === "Add" ? "Successfully Added!" : "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: typeTab === "Add" ? "Successfully Added!" : "Successfully Updated!",
              type: "success",
            });
          }, 1900);
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Error",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Error",
              type: "error",
            });
          }, 1900);
        }
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  }

  async addEditEquipmentLog(
    navigate,
    setLoading,
    setToastConfig,
    toastConfig,
    data,
    typeTab,
    setAddEqupmentLogPopup,
    refreshApi
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/obligations/addEditEquipmentLog`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.isSuccess) {
          setAddEqupmentLogPopup(false);
          refreshApi();
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: typeTab === "Add" ? "Successfully Added!" : "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: typeTab === "Add" ? "Successfully Added!" : "Successfully Updated!",
              type: "success",
            });
          }, 1900);
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Error",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Error",
              type: "error",
            });
          }, 1900);
        }
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  }

  async changeFinancialStatus(
    navigate,
    setLoading,
    setToastConfig,
    toastConfig,
    apiPayload,
    setChangeFinancialStatusPopup,
    refreshApi
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/obligations/change-financial-status`, apiPayload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.isSuccess) {
          setChangeFinancialStatusPopup(false);
          refreshApi();
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Successfully Updated!",
              type: "success",
            });
          }, 1900);
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Error",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Error",
              type: "error",
            });
          }, 1900);
        }
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  }

  async changeDocketFinancialStatus(
    navigate,
    setLoading,
    setToastConfig,
    toastConfig,
    apiPayload,
    setChangeFinancialStatusPopup,
    refreshApi
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/docket/change-financial-status`, apiPayload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.isSuccess) {
          setChangeFinancialStatusPopup(false);
          if (refreshApi) refreshApi();
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Successfully Updated!",
              type: "success",
            });
          }, 1900);
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Error",
            type: "error",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Error",
              type: "error",
            });
          }, 1900);
        }
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  }

  async getFeeScheduleType(navigate, gFeeScheduleTypeId) {
    try {
      const val = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/feeschedule/get-feeschedulebyid?gFeeScheduleFeeId=${gFeeScheduleTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${this.pathname}`,
          },
        }
      );
      return val?.data?.data;
    } catch (error) {
      if (!error?.response) {
        navigate(`/error/500`);
      } else if (error?.response?.status === 401) {
        logOut();
      }
    }
  }

  getObligationAccrualFrequencyData(navigate, setFrequencyDropdown) {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/get-obligation-accrual-frequency-data`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setFrequencyDropdown(
          val?.data?.data?.map((item) => ({
            id: item.gFrequencyID,
            name: item.sName,
          }))
        );
      })
      .catch((error) => {
        if (!error?.response) {
          navigate("/error/500");
        } else if (error?.response?.status === 401) {
          logOut();
        }
      });
  }
}
